var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.value,"persistent":"","max-width":"700"}},[_c('d-carabinero',{attrs:{"local":_vm.local}},[_c('v-spacer'),_c('v-btn',{attrs:{"color":"secondary"},on:{"click":function($event){return _vm.$emit('input', false)}}},[_vm._v(" cerrar ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }